import { CustomCell } from '../../components/custom-cell';
import { MarkerCell } from './components/marker-cell';
import { getNumericOperators } from '../../utils/getNumericOperators';
import { getStringOperators } from '../../utils/getStringOperators';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const TABLE_COLUMNS = () => {
	return [
		{
			headerName: '#',
			field: 'id',
			width: 100,
			minWidth: 100,
			align: 'center',
			headerAlign: 'center',
			type: 'number',
			cellClassName: 'id',
			filterOperators: getNumericOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Название',
			field: 'name',
			flex: 1,
			filterOperators: getStringOperators(),
			renderCell: params => CustomCell(params),
		},
		{ headerName: 'Адрес', field: 'address', flex: 2, filterOperators: getStringOperators() },
		{
			headerName: '',
			field: 'marker',
			width: 100,
			align: 'center',
			headerAlign: 'center',
			sortable: false,
			filterable: false,
			renderCell: params => MarkerCell(params),
		},
	];
};
